<template>
  <div>
    <h2>{{ quote.goodsDescriptions }}</h2>
    <b-row class="mb-2">
      <b-col>
        <span>เลขที่งาน: {{ quote.customerJobId ? quote.customerJobId : '-' }}</span>
        <br />
        <span>ชื่องาน(ภายใน): {{ quote.title ? quote.title : '-' }}</span>
        <br />
        <span>ดูแล้ว: {{ quote.viewCount ? quote.viewCount : '0' }} ครั้ง</span>
      </b-col>
      <b-col>
        <b-button
          v-if="quote.status < 20"
          class="float-right"
          @click="closeJob"
          variant="danger"
        >ปิดงาน</b-button>
        <b-button
          v-if="quote.status < 20"
          :to="{ name: 'แก้ไขใบขอราคา', params: {jobId:quote._id}}"
          class="float-right mr-2"
          variant="primary"
        >แก้ไข</b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12" xl="8">
        <MainDetail :quote="quote" :profile="profile" :showStatus="true" />
      </b-col>
      <b-col md="12" xl="4">
        <b-card class="d-lg-down-none job-docs-position-fixed">
          <h5 style="width: 100%">ใบเสนอราคา</h5>
          <h6 class="text-logisty-profile-heading mt-4">เอกสารของเรา</h6>
          <FileList
            ref="shipperQuoteFileList"
            :refId="quote._id"
            docType="shipper-quote"
            docClass="request"
          />
          <h6 v-if="quote.status < 20" class="text-logisty-profile-heading mt-2">ส่งเอกสารเพิ่ม</h6>
          <UploadFile
            v-if="quote.status < 20"
            ref="shipperQuoteFileUpload"
            docType="shipper-quote"
            :refId="quote._id"
            :showHeader="false"
            :noDrag="true"
          />
          <hr class="divider" />
          <h6 class="text-logisty-profile-heading mt-4">เอกสารจากผู้ขนส่ง</h6>
          <FileListWithName
            ref="carrierQuoteFileList"
            :refId="quote._id"
            docType="shipper-quote"
            :preventDelete="true"
            docClass="response"
          />
        </b-card>
        <b-card class="d-xl-none">
          <h5 style="width: 100%">ใบเสนอราคา</h5>
          <h6 class="text-logisty-profile-heading mt-4">เอกสารของเรา</h6>
          <FileList
            ref="shipperQuoteFileList"
            :refId="quote._id"
            docType="shipper-quote"
            docClass="request"
          />
          <h6 v-if="quote.status < 20" class="text-logisty-profile-heading mt-2">ส่งเอกสารเพิ่ม</h6>
          <UploadFile
            v-if="quote.status < 20"
            ref="shipperQuoteFileUpload"
            docType="shipper-quote"
            :refId="quote._id"
            :showHeader="false"
            :noDrag="true"
          />
          <hr class="divider" />
          <h6 class="text-logisty-profile-heading mt-4">เอกสารจากผู้ขนส่ง</h6>
          <FileListWithName
            ref="carrierQuoteFileList"
            :refId="quote._id"
            docType="shipper-quote"
            :preventDelete="true"
            docClass="response"
          />
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import MainDetail from './MainDetail'
import Quote from '../../services/http/Quote'
import Profile from '../../services/http/Profile'

import UploadFile from '../../components/UploadFile'
import FileList from '../../components/FileList'
import FileListWithName from '../../components/FileListWithName'

export default {
  components: {
    MainDetail,
    UploadFile,
    FileList,
    FileListWithName
  },
  data () {
    return {
      quote: null,
      profile: null
    }
  },
  async mounted () {
    window.analytics.track('myquote-detail-open', {
      jobId: this.$route.params.jobId
    })
    this.init()
  },
  methods: {
    async init () {
      // load myquote
      try {
        var quote = new Quote()
        var data = {
          qrJobId: this.$route.params.jobId
        }
        var result = await quote.shipperGetOneQuote(data)
        if (result.code === 1) {
          this.quote = result.data
        } else if (result.code === 110) {
          alert('ไม่มีสิทธิ์ในการดูงานนี้')
          // this.$router.push({ name: 'ใบขอราคาทั้งหมด' })
        } else {
          alert('ไม่สามารถโหลดข้อมูลงานได้')
          // this.$router.push({ name: 'ใบขอราคาทั้งหมด' })
        }

        var profile = new Profile()
        var companyProfile = await profile.getPrivateProfileById(this.quote.shipper._id)

        if (companyProfile.code === 1) {
          this.profile = companyProfile.data

          // open success send viewed respose quote doc
          quote.shipperUpdateQuoDocViewed(data)
        } else {
          alert('ไม่พบข้อมูลบริษัท')
          // this.$router.push({ name: 'ใบขอราคาทั้งหมด' })
        }
      } catch (error) {
        alert('โปรดติดต่อผู้ดูแลระบบ')
        console.log(error)
      }
    },
    async closeJob () {
      if (!confirm('ต้องการปิดงานหรือไม่ หากดำเนินการแล้วจะไม่สามารถย้อนกลับ')) {
        return
      }

      var quote = new Quote()
      try {
        // do update
        var data = {
          qrJobId: this.$route.params.jobId,
          status: 20
        }
        Window.Event.$emit('showModalLoading')
        var result = await quote.shipperUpdateQuote(data)

        if (result.code === 1) {
          await this.$bvModal.msgBoxOk('ปิดงานสำเร็จ', this.$getConst('okModalClass'))
          Window.Event.$emit('closeModalLoading')
          this.init()
        } else {
          await this.$bvModal.msgBoxOk('โปรดติดต่อผู้ดูแลระบบ', this.$getConst('okModalClass'))
          Window.Event.$emit('closeModalLoading')
        }
      } catch (error) {
        console.log(error)
        await this.$bvModal.msgBoxOk('โปรดติดต่อผู้ดูแลระบบ', this.$getConst('okModalClass'))
        Window.Event.$emit('closeModalLoading')
      }
    }
  }
}
</script>
